import ActivityScreen from './ActivityScreen';
import AuditLogDetailsScreen from './AuditLogDetailsScreen';
import AddMessageScreen from './AddMessageScreen';
import wrapInTabContentContainer from '../../../AppNavigator/TabNavigation/wrapInTabContentContainer';

const screens = {
    ActivityScreen: wrapInTabContentContainer(ActivityScreen),
    AuditLogDetailsScreen: wrapInTabContentContainer(AuditLogDetailsScreen),
    AddMessageScreen: wrapInTabContentContainer(AddMessageScreen),
};

export { screens };
